import React from 'react';
import { useSelector } from 'react-redux';
import { useLabels } from 'wsm-common-data';
import Container from '../components/Container';
import Image from '../components/Image';

const Widget = () => {
	const labels = useLabels();
	const { error } = useSelector((state) => state.widgetData);

	// If there is an error, then we must be in Composer
	// because statusCode 204 is returned in store.js
	if (error) {
		return (
			<div className="composer-editor-only">
				{labels.getHTML('DISABLED_ON_WEBSITE_VEHICLE_IMAGE')}
			</div>
		);
	} else {
		return (
			<Container>
				<Image />
			</Container>
		);
	}
};

export default Widget;
